import { render, staticRenderFns } from "./SubHireCancelledList.vue?vue&type=template&id=31a83ede"
import script from "./SubHireCancelledList.vue?vue&type=script&lang=js"
export * from "./SubHireCancelledList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports